import * as redirect from "./redirectLink";

import { ILinkParams } from "../../classes/linkParams";

import { IMonthDayCellEvent } from "../EventView/MonthlyEventView/MonthDayCellEvent";

let _props: any;

export const importProps = (props: any) => {
  _props = props;
};

export const onAddEvent_DisplayClassicAddEventScreen = (event: any) => {

  const linkParams: ILinkParams = {
    action: "add",
    baseURL: "/cms/one.aspx",
    contextId: _props.contextId,
    currentDate: _props.selectedDate,
    linkName: "Add Event (with new link builder)",
    objectId: _props.objectId,
    objectType: "workspace_event",
    pageId: _props.pageId,
    parentId: _props.parentId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const onAddEvent_DisplayModernAddEventScreen = (event: any,  onClearEvent: any, onSetEventViewMode: any) => {
  event.preventDefault();
  onClearEvent();   // Clear any existing event data.
  onSetEventViewMode("ADD");
  // console.log("display modern add event screen"); // tslint:disable-line
};

export const onImportEvents = (event: any) => {

  const linkParams: ILinkParams = {
    action: "import",
    baseURL: "/cms/one.aspx",
    contextId: _props.contextId,
    currentDate: _props.selectedDate,
    linkName: "Import Events (with new link builder)",
    objectId: _props.objectId,
    objectType: "workspace_calendar",
    pageId: _props.pageId,
    parentId: _props.parentId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const onICALRSSFeed = (event: any) => {

  const linkParams: ILinkParams = {
    action: "subscribeToICalAndRssFeeds",
    baseURL: "/cms/one.aspx",
    calendarName: _props.calendarName,
    contextId: _props.contextId,
    currentDate: _props.selectedDate,
    linkName: "ICAL/RSS (with new link builder)",
    objectId: _props.objectId,
    objectType: "workspace_calendar",
    pageId: _props.pageId,
    pageName: _props.pageName,
    parentId: _props.parentId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const onSubscribeToEmailAlerts = (event: any) => {

  // Create an URL for the current page, including view mode and date.
  const returnlinkParams: ILinkParams = {
    baseURL: "/cms/one.aspx",
    currentDate: _props.selectedDate,
    linkName: "Copy Link to this view (with new link builder)",
    pageId: _props.pageId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };
  const returnURL = redirect.getLinkToNETPage(event, returnlinkParams);

  // Create a link to the Subscribe to Email Alerts page, including the link back to this page with current date and view mode.
  const linkParams: ILinkParams = {
    action: "add",
    alertType: "ContentsAlert",
    baseURL: "/alerts/AlertAE.aspx",
    currentDate: _props.selectedDate,
    linkName: "Subscribe to email alerts (with new link builder)",
    objectId: _props.parentId,
    portletInstanceId: _props.portletInstanceId,
    returnTo: returnURL,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const onExportEvents = (event: any) => {

  const linkParams: ILinkParams = {
    action: "export",
    baseURL: "/cms/one.aspx",
    contextId: _props.contextId,
    currentDate: _props.selectedDate,
    firstDay: _props.localFromDate,
    lastDay: _props.localToDate,
    linkName: "Export events (with new link builder)",
    objectId: _props.objectId,
    objectType: "workspace_calendar",
    pageId: _props.pageId,
    parentId: _props.parentId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const GetURLForCopyLink = (): string => {
  // Create an URL for the current page, including view mode and date.
  const linkParams: ILinkParams = {
    baseURL: "/cms/one.aspx",
    currentDate: _props.selectedDate,
    linkName: "Copy Link to this view (with new link builder)",
    pageId: _props.pageId,
    portalId: _props.portalId,
    portletInstanceId: _props.portletInstanceId,
    todaysDate: _props.todaysDate,
    viewMode: _props.viewMode,
  };

  return redirect.getLinkToNETPage(undefined, linkParams);
};

export const onPrint = (event: any) => {

  alert("print...");

};

export const redirectToEventDetails = (event: any, eventID: number, eventReference: string, contextId: number, selectedDate: Date, todaysDate: Date, pageId: number, parentId: number, portalId: number,
  portletInstanceId: number, viewMode: string, onStartAjaxCall: any) => {

  onStartAjaxCall();

  const linkParams: ILinkParams = {
    baseURL: "/cms/one.aspx",
    contextId,
    currentDate: selectedDate,
    linkName: "Event Details link",
    objectId: eventID, // _props.objectId,
    pageId,
    parentId,
    portalId,
    portletInstanceId,
    ref: eventReference,
    returnTo: parentId.toString(),
    todaysDate,
    viewMode,
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};

export const displayEventDetails = (event: any, eventID: number, onSetEventId: any, onSetEventScreenMode: any, onSetiCalStartDate: any, onSetDisplayedEventLocalStartDate: any, onSetDisplayedEventLocalEndDate: any) => {
  event.preventDefault();
  onSetEventId();
  onSetEventScreenMode();
  onSetiCalStartDate();
  onSetDisplayedEventLocalStartDate();
  onSetDisplayedEventLocalEndDate();
};

export const onEventInAdminMode = (event: any, eventID: number, eventReference: string, contextId: number, selectedDate: Date, pageId: number, parentId: number, portletInstanceId: number,
  viewMode: string, onStartAjaxCall: any) => {

  onStartAjaxCall();

  const linkParams: ILinkParams = {
    action: "edit",
    baseURL: "/cms/one.aspx",
    contextId,
    currentDate: selectedDate,
    objectId: eventID,
    pageId,
    parentId,
    portletInstanceId,
    viewMode,  // set to classic
    ref: eventReference,
    returnTo: parentId.toString(),
  };

  window.location.href = redirect.getLinkToNETPage(event, linkParams);
};
